import { configureStore } from '@reduxjs/toolkit';
import sessionSlice from '../features/session/sessionSlice';
import balanceSlice from '../features/balance/balanceSlice';
import languageSlice from '../features/language/languageSlice';
import notificationSlice from '../features/notification/notificationSlice';
import onlineUsersSlice from '../features/online-users/onlineUsersSlice';
import gamesSlice from '../features/games/gameSlice';

export const makeStore = () => {
    const store = configureStore({
        reducer: {
            session: sessionSlice,
            balance: balanceSlice,
            language: languageSlice,
            notification: notificationSlice,
            onlineUsers: onlineUsersSlice,
            games: gamesSlice,
        },
        devTools: true,
    });
    return store;
};
